/* eslint-disable no-undef,no-return-assign */
import { erase, token } from '../../reducers/currentUser/currentUser.reducer';

export const get = url => new Promise((resolve, reject) =>
  fetch(url, {
    method: 'get',
    headers: {
      Authorization: token(),
    },
  })
    .then((response) => {
      if (response.ok) return response.json().then(value => resolve(value));
      if (response.status === 401) { document.location = '/login'; return erase(); }
      return reject();
    }));



// WEBPACK FOOTER //
// ./src/helpers/api/get.js